let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("55QyC")).then(() => parcelRequire('7e0QN'));